import type { ReactNode } from "react";

const moats: { title: string; description: string; icon: ReactNode }[] = [
  {
    title: "First Mover",
    description: "Xeni is live and processing real cases. Every case generates training data that improves accuracy. Competitors start from zero.",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
    ),
  },
  {
    title: "Compliance DNA",
    description: "Team built and operated technology serving FCA-regulated clients. Compliance, audit, and governance are in our DNA — not bolted on. Domain expertise in immigration, finance, and education.",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><polyline points="9 12 11 14 15 10" /></svg>
    ),
  },
  {
    title: "Global Replicability",
    description: "Built for UK, already expanding. ProActive Legal (AU/NZ) partnering to deploy Xeni across hundreds of cases. Early interest from Southeast Asia. The playbook crosses borders.",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>
    ),
  },
  {
    title: "Ownership Moat",
    description: "SaaS vendors can be switched out. When you own the firm and the platform, competitors can't displace you. Each acquisition locks in revenue.",
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /><circle cx="12" cy="16" r="1" /></svg>
    ),
  },
];

export function WhyUsSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <div className="mb-5">
        <h2 className="text-[32px] font-light tracking-tight font-[family-name:var(--font-heading)]">
          Four moats. One compounding advantage
        </h2>
      </div>

      <div className="grid grid-cols-2 grid-rows-2 gap-3 mb-8" style={{ gridAutoRows: "1fr" }}>
        {moats.map((m) => (
          <div key={m.title} className="border border-[var(--color-border)] rounded-xl p-4 bg-[var(--color-surface)] h-full">
            <div className="flex items-center gap-3 mb-2">
              <span className="text-[var(--color-fg)] shrink-0">{m.icon}</span>
              <h3 className="text-[15px] font-medium font-[family-name:var(--font-heading)]">{m.title}</h3>
            </div>
            <p className="text-[12px] leading-relaxed text-[var(--color-fg-secondary)] font-light">{m.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
